module.exports = __webpack_public_path__ + "static/media/scheduler_media_coupon.0a4b6627.xlsx";